import { AfterViewInit, Component } from '@angular/core';
import { DateCellEditorBaseComponent } from '../date-cell-editor-base/date-cell-editor-base.component';
import moment from 'moment';


@Component({
    selector: 'se-date-cell-editor-popup',
    templateUrl: './date-cell-editor-popup.component.html',
    styleUrls: ['./date-cell-editor-popup.component.scss']
})
export class DateCellEditorPopupComponent extends DateCellEditorBaseComponent implements AfterViewInit {


    ngAfterViewInit(): void {
        this.formReady.emit(this.formControl);
        window.setTimeout(() => {
            if (this.dateInput) {
                this.dateInput.nativeElement.focus();
                this.dateInput.nativeElement.select();
            }
            if (this.seTimePicker) {
                this.seTimePicker.focus();
                this.seTimePicker.select();
            }
        }, 0);
    }

    setDateValue() {
        return moment(this.formControl.value);
    }

    updateDate(value) {
        this.formControl.setValue(moment(value));
    }
}
